export default __webpack_public_path__ + "9002e0378e4d8379640c0ea3bb0a2de6.svg";